import React from 'react';

export function EnergyIconAFA() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 91.15 52.45">
            <defs>
                <style>
                    {`
                        .cls-1-a {
                            stroke-width: .82px;
                        }

                        .cls-1-a, .cls-2-a, .cls-3-a {
                            stroke: #231f20;
                        }

                        .cls-1-a, .cls-3-a {
                            fill: none;
                            stroke-linecap: round;
                            stroke-linejoin: round;
                        }

                        .cls-4-a {
                            font-size: 18.42px;
                        }

                        .cls-4-a, .cls-5-a {
                            fill: #231f20;
                            font-family: Calibri-Bold, Calibri;
                            font-weight: 700;
                        }

                        .cls-2-a {
                            stroke-miterlimit: 10;
                            stroke-width: .5px;
                        }

                        .cls-2-a, .cls-6-a {
                            fill: #fff;
                        }

                        .cls-5-a {
                            font-size: 10px;
                        }

                        .cls-7-a {
                            fill: #50b848;
                        }

                        .cls-7-a, .cls-6-a {
                            stroke-width: 0px;
                        }

                        .cls-3-a {
                            stroke-width: 1.07px;
                        }
                    `}
                </style>
            </defs>
            <g id="A">
                <rect className="cls-6-a" x="69.5" y=".73" width="21.33" height="49" />
                <polygon className="cls-7-a" points="22.62 .77 .29 25.06 22.62 49.35 71.62 49.35 71.62 .77 22.62 .77" />
                <path
                    className="cls-1-a"
                    d="M23.1.41h67.27c.2,0,.36.16.36.36v48.58c0,.2-.16.36-.36.36H23.1c-.1,0-.2-.04-.26-.12L.5,25.3c-.13-.14-.13-.35,0-.48L22.84.52c.07-.07.16-.12.26-.12Z"
                />
                <path
                    className="cls-2-a"
                    d="M55.63,36.15c.14.45.22.8.26,1.06.03.26-.01.45-.14.58s-.35.21-.67.24c-.32.03-.76.05-1.32.05s-1.04,0-1.36-.03-.58-.06-.75-.11c-.17-.06-.29-.13-.36-.23-.07-.1-.13-.23-.17-.39l-1.49-4.83h-8.34l-1.41,4.7c-.05.17-.11.32-.18.44-.07.12-.19.21-.36.28-.17.07-.4.11-.7.14-.3.02-.7.04-1.19.04-.53,0-.94-.02-1.24-.06s-.5-.13-.62-.27c-.11-.14-.15-.34-.12-.6.03-.26.12-.61.26-1.04l6.85-21.31c.07-.21.15-.38.24-.51.09-.13.24-.23.44-.3.2-.07.48-.11.83-.13s.82-.03,1.41-.03c.67,0,1.21,0,1.61.03s.71.06.94.13.38.17.48.31.18.32.25.56l6.86,21.3ZM45.43,18.53h-.02l-3.14,10.21h6.3l-3.14-10.21Z"
                />
            </g>
            <g id="Layer_11" data-name="Layer 11">
                <g>
                    <line className="cls-3-a" x1="81.33" y1="30.37" x2="81.33" y2="20.01" />
                    <polyline className="cls-3-a" points="84.08 22.71 81.33 19.96 78.59 22.71" />
                </g>
                <text className="cls-4-a" transform="translate(76.62 45.94) scale(1 1.01)">
                    <tspan x="0" y="0">
                        F
                    </tspan>
                </text>
                <text className="cls-4-a" transform="translate(74.84 15.94) scale(1 1.01)">
                    <tspan x="0" y="0">
                        A
                    </tspan>
                </text>
                <text className="cls-5-a" transform="translate(83.5 9.24) scale(1 1.01)">
                    <tspan x="0" y="0">
                        +
                    </tspan>
                </text>
            </g>
        </svg>
    );
}
